'use client'

import Link from 'next/link'
import type { TeamCard } from '@/types/dashboard'

interface RecommendedTeamsProps {
  teams: TeamCard[]
}

export function RecommendedTeams({ teams }: RecommendedTeamsProps) {
  if (!teams?.length) return null

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
      {teams.map((team) => (
        <Link
          key={team.id}
          href={team.href}
          className="group rounded-2xl border border-gray-200 bg-white p-4 shadow-sm transition-all hover:border-gray-300 hover:shadow-md active:scale-[0.99]"
        >
          <div className="flex items-start justify-between gap-3">
            <h3 className="min-w-0 flex-1 text-sm font-bold text-gray-900 group-hover:text-blue-700 line-clamp-1">
              {team.name}
            </h3>

            {/* 우측 마이크로 CTA */}
            <span className="shrink-0 text-xs font-semibold text-gray-500 group-hover:text-blue-700">
              팀 보기 →
            </span>
          </div>

          {team.meta ? (
            <p className="mt-2 text-sm text-gray-600 line-clamp-2">
              {team.meta}
            </p>
          ) : (
            <p className="mt-2 text-sm text-gray-400">
              팀 소개가 아직 없습니다.
            </p>
          )}
        </Link>
      ))}
    </div>
  )
}
